export default "__VITE_ASSET__a3738387__"